import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWaitingGroupsWithTargetAction } from "../../../../redux/actions/reportActions";
import moment from "moment";
import "moment/locale/az";
import { Box, Typography } from "@mui/material";

const GroupsWithTarget = () => {
  const dispatch = useDispatch();
  const { waitingGroupsWithTarget } = useSelector((state) => state.reportDatas);

  const headers = [
    "Qrup",
    "Müəllimlər",
    "Başlama vaxtı",
    "Qrafik",
    "Mövcud tələbə sayı",
    "Targetə çatmaq üçün gərəkli say",
    "Target",
  ];

  useEffect(() => {
    dispatch(getWaitingGroupsWithTargetAction());
  }, []);

  return (
    <div className="groups-box">
      <h2>Yeni qruplar</h2>
      <Box
        sx={{
          width: "100%",
          minHeight: "300px",
          overflow: "auto",
          marginTop: 1,
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(7, 1fr)",
            gap: 0,
          }}
        >
          {headers.map((header, index) => (
            <Box
              key={index}
              sx={{
                padding: "5px 12px",
                fontWeight: "bold",
                fontSize: "12px",
                border: "1px solid lightgray",
              }}
            >
              {header}
            </Box>
          ))}
        </Box>

        {waitingGroupsWithTarget.length === 0 && (
          <Box display={"flex"} justifyContent={"center"} padding={4}>
            <Typography variant="h5">Yeni Qrup Mövcud deyil!</Typography>
          </Box>
        )}

        {waitingGroupsWithTarget?.map((item, rowIndex) => (
          <Box
            key={item._id}
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(7, 1fr)",
              gap: 0,
              borderBottom: "1px solid #e0e0e0",
              backgroundColor: rowIndex % 2 === 0 ? "#f5f5f5" : "#fff",
              "&:hover": {
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            <Box
              sx={{
                padding: "12px 16px",
                fontSize: "12px",
                borderRight: "1px solid #e0e0e0",
              }}
            >
              {item.groupName}
            </Box>
            <Box
              sx={{
                padding: "12px 16px",
                fontSize: "12px",
                borderRight: "1px solid #e0e0e0",
              }}
            >
              {item.teachers.map((teacher) => {
                return <Typography>{teacher.fullName}</Typography>;
              })}
            </Box>
            <Box
              sx={{
                padding: "12px 16px",
                fontSize: "12px",
                borderRight: "1px solid #e0e0e0",
              }}
            >
              {moment(item.groupStartDate).locale("az").format("DD MMMM YYYY")}
            </Box>
            <Box
              sx={{
                padding: "12px 16px",
                fontSize: "12px",
                borderRight: "1px solid #e0e0e0",
              }}
            >
              {item.lessonDates.map(
                (item, index) =>
                  !item.practical && (
                    <span className="lesson-date" key={index}>
                      gün: {item.day}, saat: {item.startTime}-{item.endTime}
                      <br />
                    </span>
                  )
              )}
            </Box>
            <Box
              sx={{
                padding: "12px 16px",
                fontSize: "12px",
                borderRight: "1px solid #e0e0e0",
              }}
            >
              {item.currentStudentsCount}
              {` (${item.currentStudentsPrecent})`}
            </Box>
            <Box
              sx={{
                padding: "12px 16px",
                fontSize: "12px",
                borderRight: "1px solid #e0e0e0",
              }}
            >
              {item.studentsCountToReachTarget}
              {` (${item.precentToReachTarget})`}
            </Box>
            <Box
              sx={{
                padding: "12px 16px",
                fontSize: "12px",
                borderRight: "1px solid #e0e0e0",
              }}
            >
              {item.targetStudentsCount}
            </Box>
          </Box>
        ))}
      </Box>
    </div>
  );
};

export default GroupsWithTarget;
